import { render, staticRenderFns } from "./layout-product-chars.vue?vue&type=template&id=e55a2880"
import script from "./layout-product-chars.vue?vue&type=script&lang=js"
export * from "./layout-product-chars.vue?vue&type=script&lang=js"
import style0 from "./layout-product-chars.vue?vue&type=style&index=0&id=e55a2880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports